
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Icons / certificate-lock","xmlns":"http://www.w3.org/2000/svg","width":"19.499","height":"19.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Combined Shape","d":"M7.995 18.968l-.165-.118-1.4-1.073-1.754-.235a3.154 3.154 0 01-2.687-2.535l-.03-.184-.233-1.75-1.073-1.4a3.164 3.164 0 01-.122-3.678l.118-.165 1.073-1.4.236-1.753a3.159 3.159 0 012.536-2.692l.183-.029 1.747-.233L7.83.65a3.161 3.161 0 013.839 0l1.4 1.072 1.756.235a3.156 3.156 0 012.687 2.535l.03.184.231 1.749L18.85 7.83a3.164 3.164 0 01.117 3.675l-.118.165-1.074 1.4-.234 1.755a3.156 3.156 0 01-2.535 2.687l-.184.03-1.748.231-1.4 1.074a3.161 3.161 0 01-3.675.118zM8.74 1.842L7.278 2.959l-.076.07a.745.745 0 01-.269.132l-.111.022-1.948.259A1.664 1.664 0 003.445 4.87l-.261 1.952a.828.828 0 01-.253.5l-.023.02L1.88 8.689l-.13.183a1.67 1.67 0 00.09 1.886l1.2 1.564a.742.742 0 01.148.356l.258 1.947a1.664 1.664 0 001.427 1.429l1.952.261a.767.767 0 01.356.148l1.563 1.194a1.663 1.663 0 002.018 0l1.461-1.116.009-.011a.72.72 0 01.338-.194l.111-.022 1.948-.258a1.663 1.663 0 001.428-1.427l.26-1.952a.769.769 0 01.149-.359l1.193-1.56a1.667 1.667 0 000-2.019l-1.195-1.563a.755.755 0 01-.148-.356l-.257-1.947a1.666 1.666 0 00-1.427-1.429l-1.953-.26a.749.749 0 01-.356-.148l-1.564-1.195a1.662 1.662 0 00-2.019 0zM7.725 13.684A1.726 1.726 0 016 11.96V9.908a1.728 1.728 0 011.278-1.665v-.586A2.471 2.471 0 019.75 5.184 2.506 2.506 0 0112.218 7.5l.005.159v.585A1.728 1.728 0 0113.5 9.908v2.052a1.725 1.725 0 01-1.723 1.724zM7.5 9.908v2.052a.223.223 0 00.224.223h4.052A.224.224 0 0012 11.96V9.908a.225.225 0 00-.224-.224H7.725a.224.224 0 00-.225.224zm3.222-1.724v-.527a1 1 0 00-.973-.974.973.973 0 00-.967.859l-.006.114v.527z","fill":"#011936"}})])
          )
        }
      }
    